import { useEffect, useState } from 'react'
import { filtration } from 'sections/options/sections/GlobalCashRegisters/utils'

export const useFilteredData = (data, filterValues, keys, values) => {
	const [filteredData, setFilteredData] = useState([])

	useEffect(() => {
		setFilteredData(filtration(data, keys, values))
	}, [filterValues, data])
	return filteredData
}
